<template>
<div class="card">
  <div class="card-header">
    <h5>{{ title }}</h5>
    <div v-html="subtitle">{{ subtitle }}</div>
  </div>
  <div class="card-body">
    <revchart ref="revchart" v-show="loaded" autoresize />
    <progchart ref="progchart" v-show="loaded" autoresize />
    <div v-if="!!error" class="alert alert-danger" role="alert">{{ error }}</div>
  </div>
</div>
</template>

<style>
</style>

<script>
import { Bar, HorizontalBar } from 'vue-chartjs'

const start = moment().startOf('month').format('YYYY-MM-DD')
const end = moment().add(1, 'days').format('YYYY-MM-DD')
let title = moment().format('MMMM YYYY')

export default {
  components: {
    revchart: Bar,
    progchart: HorizontalBar,
  },
  props: [
    'organization',
    'amilia_organization',
  ],
  data: () => ({
    title: title,
    subtitle: '',
    error: null,
    revenueChartData: null,
    revenueChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value, index, values) {
              return numeral(value).format('0,0 $')
            }
          }
        }],
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || ''
            if (label) label += ': '
            label += numeral(tooltipItem.yLabel).format('0,0 $')
            return label
          }
        }
      },
      title: {
        display: true,
        text: trans('daily_revenue')
      },
      legend: {
        display: false
      }
    },
    programChartData: null,
    programChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: trans('program_participants')
      },
      scales: {
        yAxes: [{ticks: {mirror: true}}]
      },
      legend: {
        display: false
      }
    },
    loaded: false,
  }),
  methods: {
    processInvoiceItems: (invoiceItems) => {
      let days = []
      let dailyRevenueMap = {}
      for (var day = 1; day <= moment().date(); day++) {
        dailyRevenueMap[day] = 0;
        days.push(day)
      }

      let sum = 0;
      let activities = []
      let participants = []
      let invoiceMap = {}
      let programParticipants = {}
      invoiceItems.forEach((ii) => {
        let day = moment(ii.InvoiceDateCreated).date();
        if (dailyRevenueMap[day] !== undefined) {
          dailyRevenueMap[day] += ii.Total;
          sum += ii.Total;
        }
        if (invoiceMap[ii.InvoiceId] === undefined) {
          invoiceMap[ii.InvoiceId] = {
            isInvoiceAdminCreated: ii.isInvoiceAdminCreated,
            Total: 0,
            IiType: ii.IiType
          }
        }
        if (ii.IiType === 'AII') {
          if (invoiceMap[ii.InvoiceId].IiType !== 'AII') invoiceMap[ii.InvoiceId].IiType = ii.IiType;
          if (activities.indexOf(ii.ActivityId) === -1)
            activities.push(ii.ActivityId);
          if (participants.indexOf(ii.ParticipantGenuinedPersonId) === -1)
            participants.push(ii.ParticipantGenuinedPersonId);
          if (!programParticipants[ii.ProgramName])
            programParticipants[ii.ProgramName] = [];
          if (programParticipants[ii.ProgramName].indexOf(ii.ParticipantGenuinedPersonId) === -1)
            programParticipants[ii.ProgramName].push(ii.ParticipantGenuinedPersonId);
        }
        invoiceMap[ii.InvoiceId].Total += ii.Total
      });

      let invoices = _.values(invoiceMap)
      let onlineCount = _.reduce(invoices, (count, i) => {
        if (!i.isInvoiceAdminCreated) count += 1;
        return count;
      }, 0);
      let online = invoices.length ? onlineCount/invoices.length : 0;

      return {
        sum: sum,
        online: online,
        participants: participants.length,
        activities: activities.length,
        days: days,
        dailyRevenue: _.values(dailyRevenueMap),
        programNames: _.keys(programParticipants),
        programParticipants: _.map(_.values(programParticipants), function(a) {return a.length})
      };
    },
    renderRevenueChart: (data) => {

    }
  },
  mounted() {
    window.comp = this;
    let revenueChart = this.$refs.revchart;
    let programChart = this.$refs.progchart;
    let url = `/organization/${this.organization.id}/sales?start=${start}&end=${end}`
    axios.get(url)
    .then(response => {
      var data = this.processInvoiceItems(response.data)

      this.subtitle = trans('in_revenue', {
        revenue: numeral(data.sum).format('0,0.00 $')
      }) + '<br/>'
      if (data.online) this.subtitle +=
        trans('registrations_were_self_served', {
          registrations: numeral(data.online).format('0.0%')
        }) + '<br/>'
      if (data.participants) this.subtitle +=
        trans('participants_registered_activities', {
          participants: data.participants,
          activities: data.activities,
          programs: data.programNames.length
        });

      this.revenueChartData = {
        labels: data.days,
        datasets: [
          {
            label: trans('revenue'),
            backgroundColor: '#f87979',
            data: data.dailyRevenue
          }
        ]
      }
      this.programChartData = {
        labels: data.programNames,
        datasets: [
          {
            label: trans('participants'),
            backgroundColor: 'rgba(100, 100, 255, 0.5)',
            data: data.programParticipants
          }
        ]
      }
      this.loaded = true
      setTimeout(() => {
        revenueChart.renderChart(this.revenueChartData, this.revenueChartOptions)
        programChart.renderChart(this.programChartData, this.programChartOptions)
      }, 1)
    })
    .catch(error => {
      this.error = error;
    });
  }
}
</script>
